import { PATH_WELCOME, enumClientIdEnum, enumHttpHeader } from "@configs";
import { IConfigClient, IMerchant } from "@interfaces";
import {
    logout,
    removeConfigClient,
    resetAuth,
    resetLineToken,
    resetMerchant,
    setAuth,
    store,
    tokenConfigClient,
} from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
// import { generateHashSignature } from "@Rocket-Innovation/components/utilities/signature";
import axios from "axios";
import CryptoJS from "crypto-js";
import queryString from "query-string";
import { v7 as uuidv7 } from "uuid";

function generateHashSignature(payload: Record<string, any>, nonce: string) {
    const sortedPayload: [string, any][] = [...Object.entries(payload)].sort();
    const jsonString = sortedPayload.toString();
    const combinedString = `${jsonString}:${nonce}`;

    // console.log(logColor.yellow, process.env.APP_SECRET_KEY, endColor);

    return new Promise<string>((resolve, reject) => {
        try {
            const hmac = CryptoJS.HmacSHA512(
                combinedString,
                process.env.REACT_APP_SECRET_KEY || "secretKey"
            );

            const base64String = CryptoJS.enc.Base64.stringify(hmac);
            resolve(base64String);
        } catch (error) {
            reject(error);
        }
    });
}

const axiosClientV2WithToken = axios.create({
    baseURL: process.env.REACT_APP_API_URL_V2,

    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "X-Requested-With": "XMLHttpRequest",
        // "ngrok-skip-browser-warning": "69420",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

axiosClientV2WithToken.interceptors.request.use(async (config) => {
    const nonce = uuidv7();
    const token = UserStore.getState().accessToken ?? store.getState().auth.auth?.accessToken;
    const sign = await generateHashSignature({ accessToken: token }, nonce!);

    // config.headers["access-token"] = token;
    config.headers["x-nonce"] = nonce;
    config.headers["x-signature"] = sign;
    config.headers["access-token"] = token;
    config.headers[enumHttpHeader.ClientId] = enumClientIdEnum.USER;
    if (!config.headers[enumHttpHeader.MerchantId]) {
        config.headers[enumHttpHeader.MerchantId] =
            store.getState().auth.merchantId || store.getState().merchant._id;
    }
    if (!config.headers[enumHttpHeader.MerchantPrefix]) {
        config.headers[enumHttpHeader.MerchantPrefix] =
            store.getState()?.auth?.merchant_prefix || store.getState()?.auth?.merchant_prefix;
    }
    if (store.getState().page.trafficSourceId) {
        config.headers["traffic-source-id"] = store.getState().page.trafficSourceId;
    }

    return config;
});

axiosClientV2WithToken.interceptors.response.use(
    (response) => {
        if (response && response.data) {
            return response;
        }
        return response;
    },

    async (error: any) => {
        // Handle errors
        if (error.response && error.response.status === 401) {
            //refreshToken
            const refreshTk = store.getState().auth.auth?.refreshToken?._id;
            const merchant = store.getState().merchant;
            if (!refreshTk) {
                store.dispatch(logout);
                store.dispatch(resetLineToken);
                store.dispatch(resetAuth);
            }
            const configClient: IConfigClient[] = store.getState().configClient;
            const index = configClient.findIndex((item) => {
                if (item.token.refreshToken) return item?.token?.refreshToken._id === refreshTk;
            });
            const merchantId = store.getState().merchant?._id;
            const hostname = window.location.hostname;
            const prefix = hostname.split(".")[0];
            if (index >= 0) {
                if (
                    configClient[index].merchantId &&
                    merchantId &&
                    configClient[index].merchantId === merchantId
                ) {
                    const refreshTokenBody = { refreshToken: refreshTk };
                    const config = {
                        headers: {
                            "client-id": enumClientIdEnum.MERCHANT,
                        },
                    };
                    try {
                        const res = await axios.post(
                            process.env.REACT_APP_API_URL_V2 + "auth/login-refresh-token",
                            refreshTokenBody,
                            config
                        );
                        if (res.status === 200) {
                            store.dispatch(setAuth(res.data));
                            const newToken = res.data.accessToken;
                            store.dispatch(
                                tokenConfigClient({ index: index, accessToken: newToken })
                            );
                            const originalRequest = error.config;

                            originalRequest.headers["access-token"] = newToken;
                            return Promise.resolve(axiosClientV2WithToken(originalRequest));
                        }
                    } catch {
                        store.dispatch(removeConfigClient(index));
                        store.dispatch(setAuth(null));
                        store.dispatch(logout);
                        store.dispatch(resetLineToken);
                        store.dispatch(resetAuth);
                        window.open(
                            "http://" +
                                prefix +
                                "." +
                                process.env.REACT_APP_CLIENT_URL +
                                PATH_WELCOME,
                            "_self"
                        );
                    }
                }
            } else {
                store.dispatch(setAuth(null));
                store.dispatch(logout);
                store.dispatch(resetLineToken);
                store.dispatch(resetAuth);
                window.open(
                    "http://" + prefix + "." + process.env.REACT_APP_CLIENT_URL + PATH_WELCOME,
                    "_self"
                );
            }
        } else if (error.response && error.response.status === 403) {
            const merchantId = store.getState().merchant._id;
            // if (!enableAccess) {
            //     store.dispatch(resetConfigClient());
            //     store.dispatch(logout());
            // }
            const config = {
                headers: {
                    "merchant-id": merchantId,
                    "client-id": "rewarding-user-site",
                },
            };
            try {
                const res = await axios.get(
                    process.env.REACT_APP_API_URL_V2 + "/auth/merchant-config",
                    config
                );
                const data = res.data.merchant as IMerchant;
                if (!data.enableAccess) {
                    store.dispatch(resetMerchant());
                    store.dispatch(logout());
                    // window.location.href = PATH_404;
                }
            } catch {
                // window.location.href = PATH_404;

                store.dispatch(resetMerchant());
                // window.location.href = PATH_404;
            }
        }
        throw error;
    }
);

export default axiosClientV2WithToken;
